/**
 * @generated SignedSource<<ad8d65606d62f912c4607db4f0a85cdb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useActiveNavLink_navItems$data = ReadonlyArray<{
  readonly href: string | null;
  readonly items?: ReadonlyArray<{
    readonly href: string | null;
  } | null> | null;
  readonly " $fragmentType": "useActiveNavLink_navItems";
}>;
export type useActiveNavLink_navItems$key = ReadonlyArray<{
  readonly " $data"?: useActiveNavLink_navItems$data;
  readonly " $fragmentSpreads": FragmentRefs<"useActiveNavLink_navItems">;
}>;

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "href",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "useActiveNavLink_navItems",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "NavBarListItem",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "NavBarList",
      "abstractKey": null
    },
    (v0/*: any*/)
  ],
  "type": "NavBarElement",
  "abstractKey": "__isNavBarElement"
};
})();

(node as any).hash = "6fd5ebb73c8a8c89b62a2d50e4ed4bd1";

export default node;
